import { useMutation } from '@apollo/client'
import React from 'react'
import { PACKAGE_EXPIRY_MAIL } from '../../graphql/mutation'
import { toast } from 'react-toastify'

interface IProps {
  closeModal: () => void
  accountData: any
}

const PackageExpiryNotificationModal: React.FC<IProps> = ({ closeModal, accountData }) => {
  const [packageExpiryMail] = useMutation(PACKAGE_EXPIRY_MAIL, {
    context: {
      headers: {
        'access-control-allow-methods': 'Accounts'
      }
    }
  })

  const sendPackageExpiryMail = async () => {
    try {
      const response = await packageExpiryMail({
        variables: {
          input: {
            bgAccountId: Number(accountData.bgAccountId)
          }
        }
      })
      if (response.data.packageExpiryMail.status === 200) {
        toast.success(response.data.packageExpiryMail.message)
        closeModal()
      } else {
        toast.error(response.data.packageExpiryMail.message)
        closeModal()
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div>
      {' '}
      <div className='card w-530px h-180px '>
        <div className='d-flex flex-column justify-content-between mx-0 px-0 mb-2'>
          <span className='mb-2 me-auto fw-bold'>
            <p>Are you sure want to send the mail to {accountData.bgAccountId}?</p>
          </span>
          <div className='d-flex justify-content-end'>
            <button type='reset' className='btn btn-sm btn-danger' onClick={closeModal}>
              Cancel
            </button>
            <button
              type='reset'
              className='btn btn-sm btn-primary  ms-3'
              onClick={sendPackageExpiryMail}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PackageExpiryNotificationModal
